export enum W4ADateFormat {
  DEFAULT = "yyyy-MM-dd'T'HH:mm:ss.SSSZZ",
}
